export function asyncDigest($scope, userFunction) {
    const digester = $scope.$digest.bind($scope);
    return (...args) => {
        return userFunction(...args).then(digester, digester);
    };
}
